var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticStyle: {
        display: "inline-block",
        position: "relative",
        width: "100%",
      },
    },
    [
      _vm.tagType == "checkbox"
        ? _c(
            "a-checkbox-group",
            {
              attrs: { value: _vm.arrayValue, disabled: _vm.disabled },
              on: { change: _vm.onChange },
            },
            _vm._l(_vm.dictOptions, function (item, key) {
              return _c(
                "a-checkbox",
                { key: key, attrs: { value: item.value } },
                [
                  _vm._v(
                    "\n      " + _vm._s(item.text || item.label) + "\n    "
                  ),
                ]
              )
            }),
            1
          )
        : _vm.tagType == "select"
        ? _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                value: _vm.arrayValue,
                disabled: _vm.disabled,
                mode: _vm.mode,
                placeholder: _vm.placeholder,
                getPopupContainer: (triggerNode) => triggerNode.parentNode,
                maxTagCount: _vm.maxTagCount,
                maxTagPlaceholder: "...",
                allowClear: "",
              },
              on: { change: _vm.onChange, select: _vm.handleSelect },
            },
            _vm._l(_vm.dictOptions, function (item, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: item.value } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { display: "inline-block", width: "100%" },
                      attrs: { title: item.text || item.label },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(item.text || item.label) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }